export default __webpack_public_path__ + "static/imx-logo-5cd8eca8ed9750db4659ebae366c84f0.png";